//Import the json file for each language//
import en from "./en.json";
import es from "./es.json";

export const defaultLocale = "en";

export const languages = {
  en: en,
  es: es,
};
